import { FC, PropsWithChildren, useContext, useState } from 'react';
import { ListsContext, SelectedList } from './contexts';

const ListsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [currentListId, setCurrentListId] = useState<number>(-1);
  const [selectedList, setSelectedList] = useState<SelectedList | null>(null);

  return (
    <ListsContext.Provider
      value={{
        currentListId,
        setCurrentListId,
        selectedList,
        setSelectedList,
      }}
    >
      {children}
    </ListsContext.Provider>
  );
};

export default ListsProvider;

export function useListsContext() {
  const context = useContext(ListsContext);
  if (context === undefined) {
    throw new Error(`useLists must be used within a ListsProvider`);
  }

  return context;
}
